// extracted by mini-css-extract-plugin
export default {"WhiteLabelHomeLayout":"MphXbJZA","WhiteLabelContentContainer":"HmGTxp79","WhiteLabelResultsContentContainer":"DIYb7jI0"};